import React from "react";
import "../style/projet.css";
import project from "../projects.json";
function Project() {
  return (
    <>
      <div className="mainProjectDiv pb-5">
        <div className="container px-5">
          <h3 className="text-center pt-5 pb-5">CHECK OUT SOME OF MY WORKS.</h3>

          {project.map((data, i) => (
            <OneProject key={i} data={data} />
          ))}
        </div>
      </div>
    </>
  );
}

const OneProject = ({ data }) => {
  return (
    <>
      <h6 className="py-3">{data["Project Area"]}</h6>
      <div className="row">
        {data["data"].map((allPRojects) => (
          <>
            <div className="col-lg-2 col-md-3 col-6 py-2 projectImageDiv">
              <a
                href={allPRojects.codeURL}
                target="shivaji"
                className="projectImageHolder"
              >
                <img
                  src={process.env.PUBLIC_URL + allPRojects.photoURL}
                  alt={allPRojects.name}
                  className=" img-fluid projectImage"
                />
              </a>
              {allPRojects.websiteLink !== undefined ? (
                <a href={allPRojects.websiteLink} target="_shivaji">
                  <p className="mt-2"> Visit Website</p>
                </a>
              ) : (
                <p className="mt-2">Not hosted Yet </p>
              )}
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default Project;
